import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 px-4 relative" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="glass-panel neon-box-purple rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-118">
          <div className="absolute -right-20 -top-20 opacity-10" data-id="element-119">
            <TrendingDownIcon size={300} className="text-[#8B5CF6]" data-id="element-120" />
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center relative z-10" data-id="element-121">
            <div className="flex-shrink-0 text-center md:text-left" data-id="element-122">
              <span className="text-6xl md:text-8xl font-black neon-text-green block leading-none" data-id="element-123">
                ?
              </span>
            </div>

            <div className="text-lg md:text-xl text-gray-300 space-y-4" data-id="element-124">
              <p data-id="element-125">
                <strong className="text-white" data-id="element-126">
                  ¿Sabías que la mayoría de los jóvenes inician su vida adulta
                  sin herramientas para gestionar su propio dinero?
                </strong>
              </p>
              <p data-id="element-127">
                Pasan años en el sistema educativo tradicional, pero rara vez
                reciben formación sobre qué hacer con su primer ingreso o
                mesada.
              </p>
              <p data-id="element-128">
                El resultado suele ser el mismo: el presupuesto desaparece en
                gastos impulsivos y suscripciones innecesarias.{' '}
                <span className="text-[#39FF14] font-semibold" data-id="element-129">
                  Estás a un paso de cambiar esa mentalidad para siempre.
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}